import { Checkbox, Field, NumericInput, TextInput, TextOutput, TimeInput } from 'Components/Core';
import FieldLabel from 'Components/Core/FieldLabel';
import {
  IWorksheetComponent,
  WorksheetEquipmentDropdown,
  WorksheetGridFieldSection,
  WorksheetRecordGrid,
} from 'Components/Worksheets/Core';
import { getMessagesForPath } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { valueOrDefault } from 'Lib/Any';
import { DateTimeDataFormat } from 'Lib/Format';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
const measurementGroupSize = 2;

let BsMeasurementsGridSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const testMeasurementsProps = useSelector(
    pipe(createWorksheetSelector!('Measurements.TestMeasurements'), valueOrDefault([] as Array<any>), (trials) =>
      trials.map((t) => ({
        dim: t.ExcludeTest,
      }))
    ),
    deepEquals
  );

  const hasParticleDensityAnyMessage = useSelector(
    pipe(
      createWorksheetSelector!('Measurements.TestMeasurements'),
      (c) => getMessagesForPath(c, `[${testMeasurementsProps.length - 1}].ParticleDensity`),
      (messages) => messages.filter((m) => m.severity === 'error'),
      (messages) => messages.length !== 0
    )
  );

  const roomTemperatureRangeMessages = useSelector(
    pipe(createWorksheetSelector!('Measurements'), (c) => getMessagesForPath(c, 'RoomTemperatureRange'))
  );

  const isExcludeTestCheckboxEnabled = (i: number) =>
    (hasParticleDensityAnyMessage && i === testMeasurementsProps.length - 1) || i === testMeasurementsProps.length - 3;

  return (
    <>
      <FieldLabel className="Field-Label">Test Measurements</FieldLabel>
      <WorksheetGridFieldSection name="Measurements.TestMeasurements" messages={roomTemperatureRangeMessages}>
        <WorksheetRecordGrid
          name={'Measurements.TestMeasurements'}
          orientation={'horizontal'}
          recordProps={{
            width: 200,
            preventRemove: true,
            preventCreate: true,
            dim: (i) => testMeasurementsProps[i]?.dim,
            recordGroupingSize: measurementGroupSize,
          }}
          fieldSet={[
            {
              name: 'SpecimenId',
              component: (i: number) => <Field input={<TextInput />} disabled={testMeasurementsProps[i]?.dim} />,
            },
            {
              name: 'Pycnometer',
              component: (i: number) => (
                <Field
                  input={<WorksheetEquipmentDropdown />}
                  equipmentType="pycnometer"
                  name="Pycnometer"
                  disabled={testMeasurementsProps[i]?.dim}
                />
              ),
            },
            {
              name: 'EmptyGasJarAndLidMass',
              component: (i: number) => <Field input={<NumericInput />} disabled={testMeasurementsProps[i]?.dim} />,
            },
            {
              name: 'GasJarLidAndSpecimenMass',
              component: (i: number) => <Field input={<NumericInput />} disabled={testMeasurementsProps[i]?.dim} />,
            },
            {
              name: 'SoakingStartTime',
              component: (i: number) => (
                <Field
                  input={<TimeInput />}
                  dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
                  disabled={testMeasurementsProps[i]?.dim}
                />
              ),
            },
            {
              name: 'SoakingEndTime',
              component: (i: number) => (
                <Field
                  input={<TimeInput />}
                  dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
                  disabled={testMeasurementsProps[i]?.dim}
                />
              ),
            },
            {
              name: 'SoakingPeriod',
              component: <Field input={<TextOutput />} />,
            },
            {
              name: 'ShakingStartTime',
              component: (i: number) => (
                <Field
                  input={<TimeInput />}
                  dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
                  disabled={testMeasurementsProps[i]?.dim}
                />
              ),
            },
            {
              name: 'ShakingEndTime',
              component: (i: number) => (
                <Field
                  input={<TimeInput />}
                  dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
                  disabled={testMeasurementsProps[i]?.dim}
                />
              ),
            },
            {
              name: 'ShakingPeriod',
              component: (i: number) => <Field input={<TextOutput />} />,
            },
            {
              name: 'GasJarLidSpecimenAndWaterMass',
              component: (i: number) => <Field input={<NumericInput />} disabled={testMeasurementsProps[i]?.dim} />,
            },
            {
              name: 'WaterTemperature1',
              component: (i: number) => <Field input={<NumericInput />} disabled={testMeasurementsProps[i]?.dim} />,
            },
            {
              name: 'GasJarLidAndWaterMass',
              component: (i: number) => <Field input={<NumericInput />} disabled={testMeasurementsProps[i]?.dim} />,
            },
            {
              name: 'WaterTemperature2',
              component: (i: number) => <Field input={<NumericInput />} disabled={testMeasurementsProps[i]?.dim} />,
            },
            {
              name: 'ParticleDensity',
              component: <Field input={<TextOutput />} />,
            },
            {
              name: 'ExcludeTest',
              component: (i: number) =>
                i % measurementGroupSize !== 0 ? (
                  <Field input={<Checkbox />} disabled={!isExcludeTestCheckboxEnabled(i)} />
                ) : (
                  <></>
                ),
            },
          ]}
        />
      </WorksheetGridFieldSection>
    </>
  );
};

BsMeasurementsGridSection = withInjectedProps(BsMeasurementsGridSection);

export { BsMeasurementsGridSection };
export default BsMeasurementsGridSection;
